import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-5 sm:gap-3.5',
    title: 'heading-m-regular',
    options: 'flex flex-wrap gap-1',
    helperWrapper: 'hidden sm:block',
    helper: 'sm:heading-xs-regular heading-m-regular cursor-pointer'
  },
  variants: {
    sizeSelected: {
      true: {
        title: 'text-primary'
      },
      false: {
        title: 'text-error'
      }
    },
    accentHelper: {
      true: {
        helper: 'text-accent'
      },
      false: {
        helper: 'text-tertiary'
      }
    }
  },
  defaultVariants: {
    sizeSelected: false,
    accentHelper: false
  }
});
